import { Spinner } from '../spinner/spinner'
import styles from './infoSection.module.css'

type Props = {
    content: JSX.Element
    loaded: boolean
}

export const InfoSection = (props: Props) => {
    const { content, loaded } = props

    const renderAsync = (element: JSX.Element) => loaded ? element : <Spinner />

    return (
        <div className={styles.container}>
            {renderAsync(content)}
        </div>
    )
}
